module.exports = __webpack_public_path__ + "static/media/bloom_spinner_grey.7b96d186.gif";